/* eslint-disable jsx-a11y/alt-text */
import { Box, Button, Container } from '@mui/material'
import { FC } from 'react'
import { Helmet } from 'react-helmet-async'
import { useSearchParams } from 'react-router-dom'
import { Api } from '../../api'
import { Loading } from '../../components/Loading'
import { Tc } from '../../components/Tc'
import { useGet } from '../../hooks/get'

const TermsConditions: FC = () => {
  const [searchParams] = useSearchParams()

  const { data } = useGet<Dto.Tc | { message: string }>(
    ['website/terms_conditions', { token: searchParams.get('token') }],
    { isPublic: true }
  )

  const handleAcceptClick = async () => {
    await Api.post('website/terms_conditions/agreement', {
      token: searchParams.get('token'),
    })
    window.location.reload()
  }

  if (!data) {
    return <Loading />
  }

  return (
    <>
      <Helmet>
        <title>Accept Terms & Conditions</title>
      </Helmet>
      <Container maxWidth="md">
        <Box py={4}>
          {'message' in data ? (
            data.message
          ) : (
            <>
              <Tc data={data} />
              <Box mt={4}>
                <Button fullWidth onClick={handleAcceptClick}>
                  Accept
                </Button>
              </Box>
            </>
          )}
        </Box>
      </Container>
    </>
  )
}

export { TermsConditions }
